import script from "./LoginComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginComponent.vue?vue&type=script&setup=true&lang=ts"

import "./LoginComponent.vue?vue&type=style&index=0&id=3be71e01&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3be71e01"]])

export default __exports__